import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import {
  usePostUpdateUOMMutation,useGetItemDetailsDataMutation
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import FileAttachmentManager  from "../../../../Components/FileAttachmentManager";
import Attachment from "../../../../utils/Attachment";
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
const EditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const IdData = location.state?.ItemId; // passed via router state

  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [showError, setShowError] = useState(false);
  const [po_response, setpo_response] = useState("");
  const [AttachmentsList, setAttachmentsList] = useState([]);

  // api variable
  const [Updateuom] = usePostUpdateUOMMutation();
  const [itemDetails] = useGetItemDetailsDataMutation();

  const [fieldErrors, setFieldErrors] = useState({
    ischeckboxEnabled:false,
    Whole_Number: false,
    UOMName: false,
  });

  
  const pageStateDefault = {
    tab: 1,
    finalstep: false,
    IdData: IdData || "",   // store here
    ischeckboxEnabled: false,
    Whole_Number: false,
    UOMName: ""
  };

  const [pageState, setPageState] = usePageState(`Edit UOM - ${IdData}`, pageStateDefault);

  const { tab, finalstep, ischeckboxEnabled, Whole_Number, UOMName } = pageState;

  useEffect(() => {
    if (IdData) {
      if (!isStateChanged(pageState, pageStateDefault)) {
      itemDetails({ doctype: "UOM", name: IdData })
        .unwrap()
        .then((response) => {
          const item = response.docs?.[0];
          const docinfo = response.docinfo;

          if (!item) return;

          setPageState({
            ...pageState,
            IdData: IdData,   // ✅ store IdData inside pageState
            ischeckboxEnabled: item.enabled,
            Whole_Number: item.must_be_whole_number,
            UOMName: item.uom_name,
          });

          setAttachmentsList(docinfo.attachments);
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    }
  }
  }, [IdData, itemDetails]);

  const handleSubmit = async () => {
    setFieldErrors({
      ischeckboxEnabled: false,
      Whole_Number: false,
      UOMName: false,
    });

    const newErrors = {
      ischeckboxEnabled: !ischeckboxEnabled,
      UOMName: !UOMName,
    };
    const hasError = Object.values(newErrors).some((error) => error);
    setFieldErrors(newErrors);

    if (hasError) return;

    const payload = {
      unitName: pageState.IdData,      // ✅ use from pageState
      enabled: ischeckboxEnabled,
      must_be_whole_number: Whole_Number,
    };

    console.log("update UOM payload:", payload);

    try {
      const response = await Updateuom(payload).unwrap();

      function stripHTML(html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
      }

      if (response.error) {
        let errorMessage = "Updation failed";

        if (response.error.data && response.error.data._server_messages) {
          try {
            const serverMessages = JSON.parse(response.error.data._server_messages);
            if (Array.isArray(serverMessages) && serverMessages.length > 0) {
              const parsedMessage = JSON.parse(serverMessages[0]);
              errorMessage = parsedMessage.message || errorMessage;
            }
          } catch (e) {
            console.warn("Failed to parse _server_messages", e);
          }
        } else {
          errorMessage =
            response.error.data?.message ||
            response.error.data?.exception ||
            errorMessage;
        }

        errorMessage = stripHTML(errorMessage);

        setptype("Error");
        setError(errorMessage);
        setShowError(true);
        return;
      }

      setpo_response(response.data);
      setError("UOM Updated successfully!");
      setptype("Success");
      setShowError(true);

      setTimeout(() => {
        navigate("/master/uom/uom-list");
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };

  return (
    <FormLayoutTwo
      title="Edit UOM"
      breadcrumbs={[
        { label: "UOM" },
        { label: "UOM List", url: "/master/uom/uom-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                     setPageState({ ...pageState, tab: 1 });
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

         <Attachment doctype="UOM"  docname={IdData}  />    
          </div>
        </div>

        <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                <Tab1
  ischeckboxEnabled={{
    value: pageState.ischeckboxEnabled,
    setValue: (val) => setPageState({ ...pageState, ischeckboxEnabled: val }),
    error: fieldErrors.ischeckboxEnabled,
  }}
  Whole_Number={{
    value: pageState.Whole_Number,
    setValue: (val) => setPageState({ ...pageState, Whole_Number: val }),
    error: fieldErrors.Whole_Number,
  }}
  UOMName={{
    value: pageState.UOMName,
    setValue: (val) => setPageState({ ...pageState, UOMName: val }),
    error: fieldErrors.UOMName,
  }}
/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default EditForm;
